export const SUPPORT_EMAIL = "smartparksupport@winreality.com";
export const SUPPORT_PHONE = "512-265-3751";

export const TEAM_COLORS = [
  "757575",
  "F24822",
  "FF9E42",
  "FFC943",
  "66D575",
  "5AD8CC",
  // Tagging V2's home team blue
  "0066CC",
  "874FFF",
  "F849C1",
] as const;
export const DEFAULT_TEAM_COLOR = "FFC943";
// Matches Tagging V2's team colors: away yellow, home blue
export const DEFAULT_AWAY_TEAM_COLOR = DEFAULT_TEAM_COLOR;
export const DEFAULT_HOME_TEAM_COLOR = "0066CC";
